import Model from '../Model'
import {uuid} from "../../utils";

export default class SupplierQuote extends Model {

    getFormAttributes() {
        return this.only(['validTo', 'validFrom', 'supplierName', 'items'])
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
//            attributes.location,
//            attributes.key_activities,
//            attributes.key_hazards,
//            attributes.given_by_name,
//            attributes.given_by_position,
//            attributes.formatted_date,
        ]
//        attributes.attendees.forEach((a) => {
//            tokens.push(a.name, a.position);
//        })
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async find(id) {
        const data = await Http.get(route('api.v2.estimation.supplier-quotes', id))
        return this.make(data);
    }

    static async all(packageReference) {
        const data = await Http.get(route('api.v2.estimation.supplier-quotes.list', {package_reference: packageReference}))
        return this.make(data)
    }

    static async forPackage(packageReference) {
        const data = await Http.get(route('api.v2.estimation.supplier-quotes.list', {package_reference: packageReference}))
        return this.make(data)
    }

    static async create(packageReference, attributes) {
        let id = uuid();
        // Get a valid UUID -
        attributes.id = id;
        await Http.post(route('api.v2.estimation.supplier-quotes.create', {
            package_reference: packageReference,
        }), this.parseAttributes(attributes))

        const data = await Http.get(route('api.v2.estimation.supplier-quotes', {
            id: id
        }))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.estimation.supplier-quotes.update', {
            id: this.id
        })
        await Http.put(url, this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes}))
        const data = await Http.get(route('api.v2.estimation.supplier-quotes', {
            id: this.id
        }))
        return this.fill(data)
    }

    async delete() {
        const url = route('api.v2.estimation.supplier-quotes.destroy', {
            id: this.id
        })
        await Http.delete(url)
    }
}
